export const FOURNISSEUR = {
  sousTypes: {
    afficheur: 'Afficheur',
    lieuDeLivraison: 'Lieu de livraison',
    bailleurPro: 'Bailleur professionnel',
    concession: 'Bailleur concession',
    bailleurPrive: 'Bailleur particulier',
    confrere: 'Confrère',
    technicien: 'Technicien',
    fournisseurMateriel: 'Fournisseur matériel',
    administrationEtAssimilee: 'Bailleur administration et assimilée',
    collectivite: 'Collectivité',
    fournisseurSupport: 'Founisseur support',
    factor: 'Factor',
    demarcheur: 'Démarcheur',
    service: 'Service',
    autre: 'Autre',
  },
  sousTypesPluriel: {
    lieuDeLivraison: 'lieux de livraison',
    afficheur: 'afficheurs',
    bailleurPro: 'professionnels',
    concession: 'concessions',
    bailleurPrive: 'particuliers',
    confrere: 'confrères',
    technicien: 'techniciens',
    fournisseurMateriel: 'fournisseurs matériel',
    collectivite: 'collectivités',
    fournisseurSupport: 'founisseurs support',
    factor: 'factors',
    demarcheur: 'Démarcheurs',
    administrationEtAssimilee: 'administrations et assimilées',
  },
};

export const EDITION_FOURNISSEUR = {
  titleCreation: 'Création fournisseur',
  titleEdition: 'Modifier fournisseur {nomCommercial}',
  actions: {
    cancel: 'Annuler',
  },
  sousTypes: {
    afficheur: 'Afficheur',
    lieuDeLivraison: 'Lieu de Livraison',
    bailleurPro: 'Professionnel',
    concession: 'Concession',
    bailleurPrive: 'Particulier',
    confrere: 'Confrère',
    technicien: 'Technicien',
    demarcheur: 'Démarcheur',
  },
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des {sousTypePluriel}',
    titleEdition: 'Modifier fournisseur',
    titleCreation: 'Création fournisseur',
  },
  informationGenerale: {
    title: 'Informations générales',
    codeAfficheur: 'Code fournisseur',
    nomJuridique: 'Raison sociale',
    siret: 'SIRET',
    apeNaf: 'APE/NAF',
    tvaIntracommunautaire: 'TVA intracommunautaire',
    role: 'Rôle',
    numeroCedant: 'Numéro de cédant',
    numeroFichier: 'Numéro de fichier de transfert',
    applicationTva: 'Application TVA :',
  },
  adresse: {
    title: 'Adresses',
  },
  coordonee: {
    title: 'Coordonnées',
    telephone: 'Téléphone',
    telephonePortable: 'Téléphone portable',
    email: 'Email',
    siteInternet: 'Site internet',
  },
  banque: {
    title: 'Coordonnées bancaires',
    rib: 'Coordonnées bancaires',
    titulaire: 'Titulaire',
    iban: 'IBAN',
    bic: 'BIC',
  },
  infoComptable: {
    title: 'Informations comptables',
    compteComptable: 'Compte comptable',
    referenceUniqueMandat: 'Référence unique mandat',
    dateSignatureMandatSepa: 'Date de signature mandat SEPA',
  },
  contact: {
    title: 'Contacts',
    haveAddress: 'Adresse postale différente du fournisseur',
  },
  commentaire: {
    title: 'Commentaires',
    commentaire: 'Commentaire',
    commentairesFactor: 'Commentaire Factor',
  },
  notifications: {
    successCreation: 'Création du fournisseur réalisée avec succès.',
    successChange: 'Modification du fournisseur réalisée avec succès.',
  },
  errors: {
    pasMultiBailleur: 'Impossible de cumuler les rôles \'professionnel\', \'particulier\', \'concession\' et \'Administration et assimilée\' ',
    utiliseDansAffixe: 'Impossible de supprimer certains rôles pour ce fournisseur',
  },
  validation: {
    numeroCedant: 'Numéro cédant',
    nomCommercial: 'Raison sociale',
  },
};

export const DETAIL_FOURNISSEUR = {
  title: 'Détail {nom}',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des {sousTypePluriel}',
    detail: 'Détail fournisseur',
  },
  tooltipFournisseurUser: 'Ce fournisseur est relié à un compte utilisateur. Pour modifier les informations, veuillez passer par la fiche utilisateur',
  tooltipAjouterContact: 'Ce fournisseur est relié à un compte utilisateur. Vous ne pouvez pas lui ajouter de contact',
  actions: {
    edit: 'Modifier',
    contrat: 'Baux',
  },
  steps: {
    infoGenerales: 'Informations générales',
    contacts: 'Contacts',
    infoBancaire: 'Informations bancaires',
    commentaires: 'Commentaires',
    piecesJointes: 'Pièces jointes',
    infoCompta: 'Informations comptables',
  },
  informationsGenerales: {
    title: 'Informations générales',
    infoAdministrative: 'Informations administrative',
    siret: 'Siret :',
    coordonees: 'Coordonnées',
    email: 'Email :',
    telFixe: 'Téléphone fixe :',
    telPortable: 'Téléphone portable :',
    adresses: 'Adresses',
    adresse: 'Adresse',
    adressePostale: 'Adresse postale :',
    adressePaiement: 'Adresse de paiement :',
    archive: 'Archivé',
    numeroCedant: 'Numéro de cédant :',
    numeroFichier: 'Numéro de fichier de transfert :',
    applicationTva: 'Application TVA :',
  },
  contacts: {
    title: 'Contacts',
  },
  infoBancaire: {
    title: 'Informations bancaires',
    libelleBanque: 'Libellé banque :',
    titulaire: 'Titulaire :',
    iban: 'IBAN :',
    bic: 'BIC :',
    modePaiement: 'Mode de paiement :',
  },
  infoCompta: {
    title: 'Informations comptables',
    compteComptable: 'Compte comptable :',
    referenceUniqueMandat: 'Référence unique mandat :',
    dateSignatureMandatSepa: 'Date de signature mandat SEPA :',
  },
  commentaires: {
    title: 'Commentaires',
    titleFactor: 'Commentaire Factor',
  },
  piecesJointes: {
    title: 'Pièces jointes',
  },
  messages: {
    suppressionDone: 'Le contact a bien été supprimé',
  },
  libelleForLogo: 'Fournisseur {nomCommercial}',
  archivage: {
    titleDesarchiver: 'Etes-vous sûr de vouloir désarchiver cet afficheur ?',
    factorTitleDesarchiver: 'Etes-vous sûr de vouloir désarchiver ce factor ?',
    factorTitle: 'Etes-vous sûr de vouloir archiver ce factor ?',
    title: 'Etes-vous sûr de vouloir archiver cet afficheur ?',
    lieuDeLivrasonTitle: 'Etes-vous sûr de vouloir archivé ce lieu de livraison ?',
    lieuDeLivrasonTitleDesarchiver: 'Etes-vous sûr de vouloir désarchiver ce lieu de livraison ?',
    sucessArchivage: 'Afficheur archivé avec succès',
    sucessDesarchivage: 'Afficheur désarchivé avec succès',
    sucessArchivageFactor: 'Factor archivé avec succès',
    sucessDesarchivageFactor: 'Factor désarchivé avec succès',
  },
};
